var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 13.3327C18.9449 13.3327 21.3327 10.9449 21.3327 7.99935C21.3327 5.05383 18.9449 2.66602 15.9993 2.66602C13.0538 2.66602 10.666 5.05383 10.666 7.99935C10.666 10.9449 13.0538 13.3327 15.9993 13.3327Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 23.332C26.6663 26.6454 26.6663 29.332 15.9997 29.332C5.33301 29.332 5.33301 26.6454 5.33301 23.332C5.33301 20.0187 10.109 17.332 15.9997 17.332C21.8903 17.332 26.6663 20.0187 26.6663 23.332Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserDark);
export default __webpack_public_path__ + "static/media/ic-user-dark.6314ccadf0d5b95bfc8e041ba2349290.svg";
export { ForwardRef as ReactComponent };